import React from "react";
import { Copy } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import SocialShareDropdown from "./SocialShareDropdown";

interface FeedbackActionButtonsProps {
  content: string;
}

const FeedbackActionButtons: React.FC<FeedbackActionButtonsProps> = ({
  content,
}) => {
  const { toast } = useToast();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      toast({
        title: "Copied to clipboard",
        description: "The feedback analysis has been copied to your clipboard.",
      });
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      toast({
        title: "Copy failed",
        description: "Failed to copy to clipboard. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <TooltipProvider>
      <div className="flex gap-2 mt-4 justify-end">
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="w-8 h-8 rounded-full flex justify-center items-center hover:bg-accent transition-colors"
              onClick={handleCopy}
              aria-label="Copy feedback analysis"
            >
              <Copy className="h-4 w-4 text-muted-foreground" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Copy feedback to clipboard</p>
          </TooltipContent>
        </Tooltip>
        
        <SocialShareDropdown content={content} />
      </div>
    </TooltipProvider>
  );
};

export default FeedbackActionButtons;